import SlideChanger from "./slide-changer.js";
import {createElement, render, remove, replace} from "../utils/render.js";
import {Keys} from "../const.js";
import {catalog} from "../data/catalog.js";

const DEFAULT_SETTINGS = {
  backButton: `slider__slide_prev`,
  nextButton: `slider__slide_next`,
  container: `slider__list`,
  item: `slider__item`,
  stepCoefficient: 1,
  gap: 0,
  isInfinityScroll: false,
}

const sliderListMarkup = (list) => {
  return (
    list.map((item) => {
      const {logoImages, images, text, code} = item;

      return (
        `<li class="slider__item">
          <img class="slider__item-image" src="${images}" alt="">

          <p class="slider__item-description">${text}</p>

          <span class="slider__item-promo-code">${code}</span>
        </li>`
      );
    }).join(`\n`)
  );
};

const sliderDotsMarkup = (list) => {
  const createDotsMarkup = list
    .map(() => {
      return (`
        <li class="slider__slide-changer-item">
          <button class="slider__slide-changer-dot" type="button" aria-label="Перейти к слайду номер 2"></button>
        </li>
      `);
    }).join(`\n`);
  return (
    `<ul class="slider__slide-changer">${createDotsMarkup}</ul>`
  );
};

const initCounter = function(counter, nodes) {
  const length = nodes.length;
  nodes.forEach((node, index) => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        counter.innerText = `${index + 1}/${length}`;
      }
    }, {threshold: 0.5});
    observer.observe(node);
  });
};

const Slider = class {
  constructor(siteBodyElement, settingAttrs = DEFAULT_SETTINGS) {
    this._siteBodyElement = siteBodyElement;
    this.settings = Object.assign(Object.assign({}, DEFAULT_SETTINGS), settingAttrs);
    this.root = this._siteBodyElement.querySelector(`.slider`);
    // this._popupClose = this.root.querySelector(`.slider__button-close`);
    // this._buttonShowSlider = this._siteBodyElement.querySelector(`.wheel-fortune__catalog-popup`);
    this.container = this.root.querySelector(`.${this.settings.container}`);
    // console.log(`this.root`);
    // console.log(this.root);
    this._stepSize = null;

    this.backButton = this.root.querySelector(`.${this.settings.backButton}`);
    this.backButton.addEventListener(`click`, this.onBackButtonClick());

    this.nextButton = this.root.querySelector(`.${this.settings.nextButton}`);
    this.nextButton.addEventListener(`click`, this.onNextButtonClick());

    window.onresize = () => {this._stepSize = null}

    this.sliderSlideChanger = this.root.querySelector(`.slider__slide-changer`);
    this.slideChanger = new SlideChanger(this.sliderSlideChanger, this);

    this._escKeyDownHandler = this._escKeyDownHandler.bind(this);
    this.showSliderPopup = this.showSliderPopup.bind(this);

    this._element = null;
    this._oldElement = null;
    this._listShow = null;
    this.slideChanger.init();
  }

  init() {
    // this._buttonShowSlider.addEventListener(`click`, this.showSliderPopup);
    // this._popupClose.addEventListener(`click`, this.showSliderPopup);
  }

  getTemplate() {
    return sliderListMarkup(this._listShow);
  }

  getElement() {
    if (!this._element){
      this._element = createElement(this.getTemplate());
      // console.log(this.getTemplate());
      // console.log(this._element);
    }

    return this._element;
  }

  removeElement() {
    this._element = null;
  }

  render(filterList, selectedSector) {
    // this._listShow = Object.values(catalog[selectedSector]);
    this._listShow = Object.values(catalog[`sport`])
      .filter((item) => item.filter.indexOf(filterList) >= 0);

    // console.log(`render`);
    // console.log(this._listShow);

    // if (this._element) {
    //   remove(this);
    // }

    // render(this.container, this);
  }

  showSliderPopup(event) {
    event.preventDefault();
    // console.log(this.getElement());

    if (this.root.classList.contains(`slider_open`)) {
      this._closeSliderPopup(event);
    } else {
      this._siteBodyElement.classList.add(`popup-open`);
      this.root.classList.add(`slider_open`);
      document.addEventListener(`keydown`, this._escKeyDownHandler);
    }
  }

  _closeSliderPopup(event) {
    event.preventDefault();
    document.removeEventListener(`keydown`, this._escKeyDownHandler);
    this._siteBodyElement.classList.remove(`popup-open`);
    this.root.classList.remove(`slider_open`);
  }

  _escKeyDownHandler(event) {
    if (event.key === Keys.ESC || event.key === Keys.ESCAPE) {
      event.preventDefault();
      this.showSliderPopup(event);
    }
  }

  get stepSize() {
    if (this._stepSize === null) {
      this._stepSize = this.root.querySelector(`.${this.settings.item}`).offsetWidth * this.settings.stepCoefficient + this.settings.gap;
    }
    return this._stepSize;
  }

  goTo(number) {
    return (`scrollBehavior` in this.container.style) ? (evt) => {
      this.container.scrollTo(this.stepSize * number, 0);
    } : (evt) => {
      this.scroll(this.stepSize * number - this.container.scrollLeft, 200);
    };
  }

  scroll(delta, animationTransition) {
    const start = this.container.scrollLeft;
    let startTime = null;
    const container = this.container;

    const step = function(lastTime) {
      if (startTime === null) {
        startTime = lastTime;
      }
      const calcProgress = Math.abs(startTime - lastTime) / animationTransition;
      const progress = (calcProgress < 1) ? calcProgress : 1;
      container.scrollTo(start + delta * progress, 0);
      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };
    requestAnimationFrame(step);
  }

  onNextButtonClick(evt) {
    // console.log(`onNextButtonClick`);

    return (`scrollBehavior` in this.container.style) ? (evt) => {
      (this.container.scrollLeft + this.container.offsetWidth === this.container.scrollWidth && this.settings.isInfinityScroll) ? this.container.scrollTo(0, 0) : this.container.scrollTo(this.container.scrollLeft + this.stepSize, 0);
    } : (evt) => {
      (this.container.scrollLeft + this.container.offsetWidth === this.container.scrollWidth && this.settings.isInfinityScroll) ? this.scroll(-this.container.scrollLeft, 200) : this.scroll(this.stepSize, 200);
    };
  }

  onBackButtonClick(evt) {
    return (`scrollBehavior` in this.container.style) ? (evt) => {
      (this.container.scrollLeft === 0 && this.settings.isInfinityScroll) ? this.container.scrollTo(this.container.scrollWidth, 0) : this.container.scrollTo(this.container.scrollLeft - this.stepSize, 0);
    } : (evt) => {
      (this.container.scrollLeft === 0 && this.settings.isInfinityScroll) ? this.scroll(this.container.scrollWidth - this.stepSize, 200) : this.scroll(-this.stepSize, 200);
    };
  }
};

export default Slider;
